import { Link } from "react-router-dom";
import {ArrowLeft} from 'lucide-react';
import { PrivacyPolicy } from "../components/legal/PrivacyPolicy";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-700 font-medium transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Volver al inicio
          </Link>
        </div>
      </div>
      <PrivacyPolicy />
    </div>
  );
}
